import ReactDOM from 'react-dom';
import devLogger from 'react-utils/devLogger';
import { getDefaultNode } from '../utils/RootNode';
import UIFullScreen from '../dialog/UIFullScreen';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const UnsafeThemeProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ThemeProvider, {
    children: children
  });
};
function doPrompt(Component, contextRootNode, additionalProps, parentComponent) {
  const element = document.createElement('div');
  const promiseCallback = (resolve, reject) => {
    const WrappedComponent = /*#__PURE__*/_jsx(UnsafeThemeProvider, {
      children: /*#__PURE__*/_jsx(UIFullScreen, {
        "data-layer-for": "Promptable",
        rootNode: contextRootNode,
        children: /*#__PURE__*/_jsx(Component, Object.assign({}, additionalProps, {
          onConfirm: resolve,
          onReject: reject
        }))
      })
    });
    if (parentComponent) {
      ReactDOM.unstable_renderSubtreeIntoContainer(parentComponent, WrappedComponent, element);
    } else {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(WrappedComponent, element);
    }
  };
  const promise = new Promise(promiseCallback);
  return promise.finally(() => {
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.unmountComponentAtNode(element);
  });
}

/**
 * @deprecated
 * The `Promptable` function is deprecated. Try mounting `UIModal` directly.'
 */
export default function Promptable(Component, contextRootNode = getDefaultNode()) {
  devLogger.warn({
    message: 'Promptable: The `Promptable` function is deprecated. Try mounting `UIModal` directly.',
    url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/7435',
    key: 'promptable-deprecation'
  });
  return (...args) => doPrompt(Component, contextRootNode, ...args);
}